// OData query shapes for the AIVector catalog (`ai/vector`).
//
// Mirrors `aiSkill.js`: a paged shape for listings (Launchpad + admin
// catalog), and richer item / itemDetail shapes for the edit + detail
// drawers. File management lives under the nested `ai/vector/{id}/file`
// route and uses the `file` shape below.
//
// Note: `files` is never sent on create/update of a vector (see the AI
// Vectors UX guide). `openAIVectorStoreId` is backend-managed and shown
// read-only.

export default {
  paged: {
    select: 'id,name,description,isActive,isManaged,openAIVectorStoreId',
    searchSelect: ['name', 'description'],
    orderBy: 'name',
  },
  item: {
    select: 'id,name,description,isActive,isManaged,openAIVectorStoreId',
  },
  itemDetail: {
    select:
      'id,name,description,isActive,isManaged,openAIVectorStoreId,creator,modifier,created,updated',
  },
  // Nested file listing (`ai/vector/{vectorId}/file/paged`).
  // NOTE: `openAIFileId` is NOT a direct property of `AIVectorFile` — it lives
  // inside the `file` (`JsonAttachmentItem`) object. Putting it (or any nested
  // field) in `$select` makes the OData binder throw "Could not find a property
  // named 'openAIFileId'". We intentionally omit `$select` here and fetch the
  // full record so the whole `file` JSON (fileName, size, openAIFileId, …) is
  // available without enumerating nested fields.
  file: {
    orderBy: 'order',
  },
};
